"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Title = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Icon_1 = require("./Icon");
var accessors_1 = require("../themes/accessors");
var StyledTitle = styled_components_1.default('span')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  font-family: ", ";\n  ", ";\n  fill: currentColor;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n  color: ", ";\n  font-size: ", "px;\n  font-weight: ", ";\n  font-family: ", ";\n  ", ";\n  fill: currentColor;\n"])), function (props) { return accessors_1.textColor(props.color)(props); }, function (props) { return accessors_1.fontSize("h" + props.level)(props); }, function (props) { return props.level > 3 ? 400 : 700; }, accessors_1.fontFamily('sansSerif'), function (props) { return props.uppercase ? 'text-transform: uppercase;' : ''; });
var StyledTitleIcon = styled_components_1.default(Icon_1.Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding-right: ", "px;\n"], ["\n  padding-right: ", "px;\n"])), accessors_1.space('sm'));
var FillingSpan = styled_components_1.default('span')(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1;\n"], ["\n  flex: 1;\n"])));
var Title = function (_a) {
    var level = _a.level, title = _a.title, _b = _a.uppercase, uppercase = _b === void 0 ? false : _b, _c = _a.iconName, iconName = _c === void 0 ? null : _c, _d = _a.color, color = _d === void 0 ? 'contrast' : _d, otherProps = __rest(_a, ["level", "title", "uppercase", "iconName", "color"]);
    return (react_1.default.createElement(StyledTitle, __assign({ as: "h" + level, level: level, color: color, uppercase: uppercase }, otherProps),
        iconName ? react_1.default.createElement(StyledTitleIcon, { name: iconName }) : react_1.default.createElement(react_1.default.Fragment, null),
        react_1.default.createElement(FillingSpan, null, title)));
};
exports.Title = Title;
exports.default = exports.Title;
var templateObject_1, templateObject_2, templateObject_3;
